export function sortMenuItems(
  navigationItems: { id: string; orderIndex: number }[],
  TaskItem: any,
  MultiOrderAddOnItem: any
) {
  const sortedMenuItems = navigationItems.sort(
    (a, b) => a.orderIndex - b.orderIndex
  );
  const sortedMenuList = [TaskItem, MultiOrderAddOnItem, ...sortedMenuItems];
  return sortedMenuList;
}
